import service from "@/services";

interface LoginProps {
  email: string;
  password: string;
}

interface MemberProfile {
  id: string;
  client_id: string;
  name: string;
  email: string;
  role: string;
}

interface AuthenticationSuccess {
  kind: "success";
  access_token: string;
  user: MemberProfile;
}

interface AuthenticationNewPasswordRequired {
  kind: "new_password_required";
  session_id: string;
}

interface AuthenticationError {
  kind: "WRONG_CREDENTIAL" | "USER_NOT_FOUND";
  message: string;
}

export type LoginReturnData =
  | AuthenticationSuccess
  | AuthenticationNewPasswordRequired
  | AuthenticationError;

export const login = async (loginObj: LoginProps): Promise<LoginReturnData> => {
  try {
    const response = await service.post<LoginReturnData>(
      `/authenticate`,
      loginObj,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    );
    return response;
  } catch (error: any) {
    if (error.response?.data) {
      return error.response.data.detail;
    }
    throw error;
  }
};

export type ChangePasswordProps = {
  session_id: string;
  email: string;
  password: string;
  confirm: string;
};

export const changePassword = async (
  changePasswordObj: ChangePasswordProps,
): Promise<LoginReturnData> => {
  try {
    const response = await service.post<LoginReturnData>(
      `/new-password`,
      changePasswordObj,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    );
    return response;
  } catch (error: any) {
    if (error.response?.data) {
      return error.response.data.detail;
    }
    throw error;
  }
};

export const logout = async (): Promise<void> => {
  await service.post("/sign-out");
};

interface ForgetPasswordRequest {
  email: string;
}

interface ForgetPasswordConfirmRequest {
  email: string;
  confirmation_code: string;
  password: string;
}

export const forgetPassword = async (
  data: ForgetPasswordRequest,
): Promise<void> => {
  try {
    const response = await service.post("/forget-password", data);
    if (response === null) {
      return;
    }
  } catch (error: any) {
    if (error.response?.data) {
      throw error.response.data;
    }
    throw error;
  }
};

export const forgetPasswordConfirm = async (
  data: ForgetPasswordConfirmRequest,
): Promise<void> => {
  try {
    const response = await service.post("/forget-password-confirm", data);
    if (response === null) {
      return;
    }
    // return response;
  } catch (error: any) {
    if (error.response?.data) {
      throw error.response.data;
    }
    throw error;
  }
};

export type SignUpRequest = {
  email: string;
  password: string;
};

export type SignUpResponse = {
  status: string;
  message: string;
  cognito_session: string;
};

export const signUp = async (data: SignUpRequest): Promise<SignUpResponse> => {
  const url = `/signup`;
  try {
    const response = await service.post<SignUpResponse>(url, data);
    return response;
  } catch (error) {
    console.error("Failed to sign up:", error);
    throw error;
  }
};

export type SignUpConfirmRequest = {
  email: string;
  cognito_session: string;
  confirmation_code: string;
  company_name: string;
};

export type SignUpConfirmResponse = {
  status: string;
  message: string;
  access_token: string;
  user: MemberProfile | null;
};

export const signUpConfirm = async (
  data: SignUpConfirmRequest,
): Promise<SignUpConfirmResponse> => {
  const url = `/signup-confirm`;
  try {
    const response = await service.post<SignUpConfirmResponse>(url, data);
    return response;
  } catch (error) {
    console.error("Failed to confirm sign up:", error);
    throw error;
  }
};
